{
  "Use AirPlay": "AirPlay verwenden"
}
